/**
 * Quiz Game Module
 * 
 * Family quiz game with multiple choice, true/false, and text answer questions.
 * Supports categories, difficulty levels, and timed rounds.
 * 
 * @example
 * ```typescript
 * import { useQuiz, QuizCategory, QuizQuestion } from '@/modules/quiz';
 * 
 * const { categories, startQuiz, currentQuestion, submitAnswer } = useQuiz();
 * 
 * // Start a quiz session
 * await startQuiz({ category_id: 'some-id', question_count: 10 }, 'free');
 * 
 * // Submit an answer
 * const result = await submitAnswer(optionIndex, timeTakenMs);
 * ```
 */

// Types
export * from './types';

// Hooks
export { useQuiz } from './hooks/useQuiz';

